export const DOMAIN = "http://svcy.myclass.vn/api/ToDoList";

// export const DOMAINJIRA = "http://casestudy.cyberlearn.vn/api";
export const DOMAINJIRA = "https://jiranew.cybersoft.edu.vn/api";
export const TOKENCYBERSOFT =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZW5Mb3AiOiJOb2RlSlMgMzQiLCJIZXRIYW5TdHJpbmciOiIxMS8wNC8yMDI0IiwiSGV0SGFuVGltZSI6IjE3MTI3OTM2MDAwMDAiLCJuYmYiOjE2OTMwNjkyMDAsImV4cCI6MTcxMjk0MTIwMH0.dcAxAOtlLVw2muO5YfsiVtNNxI5pFOC3YUAx-VQvbPQ";
export const TOKEN = "access_token";
export const APIKEYTINY = "1znihmkkdaqy5vyhh1kpsfnlcyr1ataamvl0pjzsfprw87rm";
export const USER_LOGIN = "user_login;";
export const STATUS__CODE = {
  SUCCESS: 200,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
};
